// extracted by mini-css-extract-plugin
export default {"card":"Termes_card__ylwhE","article":"Termes_article__ngvV2"};